import PlusCircleIcon from "mdi-react/PlusCircleIcon";
import { Fragment, ReactNode } from "react";

/**
 * manage layout of heading with action button in CommonsList, CommunitiesList, EventCourseList, BestPracticeList. show button with + icon for small screen and full text button for bigger screen
 */
const PageHeadingWtButton = ({ headingText, desktopButtonText, showButton = true, buttonHandler }: {
  headingText: ReactNode; // ReactNode describes anything that can be rendered: React elements, strings, numbers, and the special values null or undefined. React element is a specific type of object that React understands and can render. 
  desktopButtonText: ReactNode;
  buttonHandler: () => void;
  showButton?: boolean;
}) => {
  return (
    <Fragment>
      <h1>{headingText}</h1>
      <div className="float-right">
        {showButton &&
          <Fragment>
            <button className="btn btn-primary ml-3 float-right d-none d-md-block" onClick={buttonHandler}>
              {desktopButtonText}
            </button>
            <button className="btn btn-link p-0 float-right d-md-none" onClick={buttonHandler}>
              <PlusCircleIcon size={'2rem'} />
            </button>
          </Fragment>
        }
      </div>
    </Fragment>
  )
};

export default PageHeadingWtButton;
